import { render, staticRenderFns } from "./ComisionForm.vue?vue&type=template&id=2b4522af&scoped=true"
import script from "./ComisionForm.vue?vue&type=script&lang=js"
export * from "./ComisionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4522af",
  null
  
)

export default component.exports